"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { MEMES_CONTRACT } from "@/constants/constants";
import type { CollectedCard } from "@/entities/IProfile";
import { CollectedCollectionType } from "@/entities/IProfile";
import type { ApiNft } from "@/generated/models/ApiNft";
import type { ApiNftsPage } from "@/generated/models/ApiNftsPage";
import type { ApiProfileMin } from "@/generated/models/ApiProfileMin";
import { commonApiFetch } from "@/services/api/common-api";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
interface UseUserPrevoteCardsProps {
  readonly user: ApiProfileMin;
  readonly enabled?: boolean | undefined;
}
const toCollectedCard = (nft: ApiNft): CollectedCard => ({
  collection: CollectedCollectionType.MEMES,
  token_id: nft.id,
  token_name: nft.name || `The Memes #${nft.id}`,
  img: nft.scaled,
  tdh: typeof nft.tdh === "number" ? nft.tdh : null,
  rank: typeof nft.tdh_rank === "number" ? nft.tdh_rank : null,
  seized_count: null,
  szn: null
});
export const useUserPrevoteCards = t0 => {
  const $ = _c(19);
  const {
    user,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const rawIds = user.artist_of_prevote_cards;
  let uniqueIds;
  if ($[0] !== rawIds) {
    uniqueIds = Array.from(new Set(rawIds.filter(_temp)));
    uniqueIds.sort(_temp2);
    $[0] = rawIds;
    $[1] = uniqueIds;
  } else {
    uniqueIds = $[1];
  }
  const prevoteCardIds = uniqueIds;
  const t2 = prevoteCardIds.join(",");
  let t3;
  if ($[2] !== t2) {
    t3 = [QueryKey.NFTS, {
      contract: MEMES_CONTRACT,
      ids: t2,
      scope: "artist-prevote-cards"
    }];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== prevoteCardIds) {
    t4 = async () => await commonApiFetch({
      endpoint: "nfts",
      params: {
        contract: MEMES_CONTRACT,
        id: prevoteCardIds.join(",")
      }
    });
    $[4] = prevoteCardIds;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = enabled && prevoteCardIds.length > 0;
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      queryKey: t3,
      queryFn: t4,
      enabled: t5,
      staleTime: 300000
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const {
    data,
    isLoading,
    isError
  } = useQuery(t6);
  let t7;
  bb0: {
    if (typeof data?.data.length !== "number") {
      let t8;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [];
        $[10] = t8;
      } else {
        t8 = $[10];
      }
      t7 = t8;
      break bb0;
    }
    let t8;
    if ($[11] !== data.data || $[12] !== prevoteCardIds) {
      const cardsById = new Map();
      for (const nft of data.data) {
        cardsById.set(nft.id, toCollectedCard(nft));
      }
      t8 = prevoteCardIds.map(id_0 => cardsById.get(id_0)).filter(_temp3);
      $[11] = data.data;
      $[12] = prevoteCardIds;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    t7 = t8;
  }
  const prevoteCards = t7;
  let t8;
  if ($[14] !== isError || $[15] !== isLoading || $[16] !== prevoteCardIds || $[17] !== prevoteCards) {
    t8 = {
      prevoteCards,
      prevoteCardIds,
      isLoading,
      isError
    };
    $[14] = isError;
    $[15] = isLoading;
    $[16] = prevoteCardIds;
    $[17] = prevoteCards;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
function _temp(id) {
  return Number.isFinite(id);
}
function _temp2(a, b) {
  return b - a;
}
function _temp3(card) {
  return !!card;
}